import { Button, Form } from "react-bootstrap"
import { useState } from "react"
import { toast } from "react-toastify"

interface EmailOtpProps {
  onSubmit: (code: string) => Promise<void>
  onCancel: () => void
}

export const EmailOtp = ({ onSubmit, onCancel }: EmailOtpProps) => {
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await onSubmit(code)
    } catch (e) {
      console.error(e)
      toast.error("Unexpected error")
    } finally {
      setLoading(false)
    }
  }

  return <Form onSubmit={handleSubmit} className="d-flex flex-column gap-2">
    <Form.Control type="text" placeholder="Code" value={code} onChange={e => setCode(e.target.value)} autoFocus />
    {loading ? <Button variant="success" type="submit" disabled>Verifying...</Button> : <Button variant="success" type="submit" disabled={code.length !== 8}>Verify</Button>}
    <Button variant="secondary" onClick={() => onCancel()} disabled={loading}>Cancel</Button>
  </Form>
}
